/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  statistics_miz_343: [],
  maksam_monitoring_of_objects: [],
  maksam_pollution_stats: [],
  statistics: [],
  statisticsReport: [],
  statisticsReportmiz: [],
}
